import Console from './Console';
export default function Workspace() { return <Console />; }
